module.exports = __webpack_public_path__ + "static/media/good-and-mad.9543e578.jpg";